/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Presets_None_TitleInputs */

const en_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Presets Available`)
};

const fr_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prereglage disponible`)
};

const de_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen verfügbar`)
};

const it_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset disponibile`)
};

const ru_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предустановки отсутствуют`)
};

const es_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ajustes preestablecidos disponibles`)
};

const zh_cn2_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无预设可用`)
};

const ja_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットは利用できません`)
};

const hi_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रीसेट उपलब्ध नहीं है`)
};

const pt_pt2_video_export_export_presets_none_title = /** @type {(inputs: Video_Export_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição disponível`)
};

/**
* | output |
* | --- |
* | "No Presets Available" |
*
* @param {Video_Export_Export_Presets_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_presets_none_title = /** @type {((inputs?: Video_Export_Export_Presets_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Presets_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_presets_none_title(inputs)
	if (locale === "de") return de_video_export_export_presets_none_title(inputs)
	if (locale === "it") return it_video_export_export_presets_none_title(inputs)
	if (locale === "ru") return ru_video_export_export_presets_none_title(inputs)
	if (locale === "es") return es_video_export_export_presets_none_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_presets_none_title(inputs)
	if (locale === "ja") return ja_video_export_export_presets_none_title(inputs)
	if (locale === "hi") return hi_video_export_export_presets_none_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_presets_none_title(inputs)
	return en_video_export_export_presets_none_title(inputs)
});